import { useContext, useMemo } from 'react';
import {
    CircleCheckIcons,
    ClipBoardIcons,
    ListCheckIcons,
    NewUserIcons,
    ShieldAlertIcons,
    StarIcons,
    UsersIcons,
    BrainIcon,
} from '../../../../../icons/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../utils/redux_store/store';
import { JobOpeningsContext } from '../../../../../utils/contexts/JobOpening';

export const useGetSidebarButtons = () => {
    const { jobOpeningElements } = useContext(JobOpeningsContext);
    const { subscriptions } = useSelector((state: RootState) => state.subscriptions);

    return useMemo(
        () => [
            {
                label: 'All Applicants',
                disabled: false,
                Icon: UsersIcons,
            },
            {
                label: 'New Applicants',
                disabled: false,
                Icon: NewUserIcons,
            },
            {
                label: 'Suitable Applicants',
                disabled: false,
                Icon: CircleCheckIcons,
            },
            {
                label: 'Outstanding Applicants',
                disabled: false,
                Icon: StarIcons,
            },
            {
                label: 'Assessment Applicants',
                disabled: false,
                Icon: ClipBoardIcons,
            },
            {
                label: 'Unsuccessful Applicants',
                disabled: false,
                Icon: ShieldAlertIcons,
            },
            {
                label: 'ShortList Applicants',
                disabled: false,
                Icon: ListCheckIcons,
            },
            ...(jobOpeningElements?.includes('Psychometric')
                ? [
                    {
                        label: 'Psychometric',
                        disabled: false,
                        Icon: BrainIcon,
                    },
                ]
                : []),
            ...(jobOpeningElements?.includes('Wellness')
                ? [
                    {
                        label: 'Wellness',
                        disabled: false,
                        Icon: ListCheckIcons,
                    },
                ]
                : []),
        ],
        [jobOpeningElements, subscriptions?.hierTalentPsychometricFaxtor],
    );
};